import { createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "../../../redux/slice";

import * as api from "../api";

export const doGetAllOrders = createAsyncThunk("orders/doGetAllOrders", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doGetAllOrders(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doUploadOrders = createAsyncThunk("orders/doUploadOrders", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doUploadOrders(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doCreateOrder = createAsyncThunk("orders/doCreateOrder", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doCreateOrder(params);
    if (!error) thunkAPI.dispatch(setMessage("You action has been completed successfully"));
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doCreateMutiOrders = createAsyncThunk("orders/doCreateMutiOrders", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doCreateMutiOrders(params);
    if (!error) thunkAPI.dispatch(setMessage("You action has been completed successfully"));
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doDeleteOrder = createAsyncThunk("orders/doDeleteOrder", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doDeleteOrder(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doUpdateOrder = createAsyncThunk("orders/doUpdateOrder", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doUpdateOrder(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doDetailOrder = createAsyncThunk("orders/doDetailOrder", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doDetailOrder(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doDetailTrackingOrder = createAsyncThunk("orders/doDetailTrackingOrder", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doDetailTrackingOrder(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doDetailPublicOrder = createAsyncThunk("orders/doDetailPublicOrder", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doDetailPublicOrder(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doBulkDeleteOrders = createAsyncThunk("orders/doBulkDeleteOrders", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doBulkDeleteOrders(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doBulkUpdateOrders = createAsyncThunk("orders/doBulkUpdateOrders", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doBulkUpdateOrders(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doBulkUpdateDeliveryDate = createAsyncThunk(
  "orders/doBulkUpdateDeliveryDate",
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.doBulkUpdateDeliveryDate(params);
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  },
);
